import React from "react";
import {ProductVisibleVoucher} from "./ProductVisibleVoucher";

export function PurchaseVoucher({type}: { type: string }) {
  return <ProductVisibleVoucher type={type} />
}
